import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import * as fromModels from '@models';

import { etlRoutes } from '@etl/urlmap';
import { ApplicationHttpClient } from './../http-client';
import { ExceptionService } from '@base/exceptions.service';

@Injectable()
export class EtlService {
  private httpOptions = {};
  private mapRoutes = etlRoutes;

  constructor(
    private http: ApplicationHttpClient,
    private exceptionService: ExceptionService,
  ) {}

  getEtls(): Observable<fromModels.Etl[]> {
    return this.http.Get(this.mapRoutes.list).pipe(
      map(etls => etls['results']),
      catchError((err: HttpErrorResponse) => throwError(err))
    );
  }

  addEtl(etl: fromModels.Etl): Observable<fromModels.Etl> {
    return this.http.Post(this.mapRoutes.list, etl)
    .pipe(
      map((newEtl: fromModels.Etl) => newEtl),
      catchError((err: HttpErrorResponse) => {
        const e = this.exceptionService.errorHandling(err);
        return throwError(e);
      })
    );
  }

  deleteEtl(etl: fromModels.Etl): Observable<boolean> {
    return this.http.Delete(`${this.mapRoutes.list}${etl.id}/`).pipe(
      map((response) => true),
      catchError((err: HttpErrorResponse) => {
        const e = this.exceptionService.errorHandling(err);
        return throwError(e);
      })
    );
  }

  updateEtl(etl: fromModels.Etl): Observable<fromModels.Etl> {
    const endpoint = `${this.mapRoutes.list}${etl.id}/`;
    return this.http.Put(endpoint, etl).pipe(
      map((response: fromModels.Etl) => response),
      catchError((err: HttpErrorResponse) => {
        const e = this.exceptionService.errorHandling(err);
        return throwError(e);
      })
    );
  }

  triggerAction(etl: fromModels.Etl): Observable<fromModels.Etl> {
    const endpoint = `${this.mapRoutes.list}${etl.id}/start-process/`;
    return this.http.Get(endpoint).pipe(
      map((response: fromModels.Etl) => response),
      catchError((err: HttpErrorResponse) => {
        const e = this.exceptionService.errorHandling(err);
        return throwError(e);
      })
    );
  }

  loadDetails(etl: fromModels.Etl): Observable<fromModels.Etl> {
    const endpoint = `${this.mapRoutes.list}${etl.id}/job-status/`;
    return this.http.Get(endpoint).pipe(
      map((response: fromModels.Etl) => response),
      catchError((err: HttpErrorResponse) => {
        const e = this.exceptionService.errorHandling(err);
        return throwError(e);
      })
    );
  }
}
